import myAxios from "@/plugins/axios";

const campaignService = {

    loadCampaigns() {
        return myAxios.privateInstance
            .get(`/campaign`).then(resp => {
                return resp
            })
            .catch(error => {
                throw new Error(error);
            })
    }
}

export default campaignService